(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-futsal/assets/javascripts/status.js') >= 0) return;  svs.modules.push('/components/themes/sport-futsal/assets/javascripts/status.js'); "use strict";

(function (svs) {
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.sport_futsal = svs.themes.sport_futsal || {};

  svs.themes.sport_futsal.isEnded = function (status) {
    if (_.contains([28, 31, 32, 33, 41], status)) {
      return true;
    }

    return false;
  };

  svs.themes.sport_futsal.isFinished = function (status) {
    if (_.contains([31, 32, 33, 41], status)) {
      return true;
    }

    return false;
  };


  svs.themes.sport_futsal.isFullTimeOrPassed = function (status, options) {
    options = _.extend({
      includeFullTime: true,
      includePauses: true,
      includeFinished: true
    }, options);
    var statusesForOvertimeOrPenalties = [19, 20, 21, 22];

    if (options.includeFullTime) {
      statusesForOvertimeOrPenalties.push(31, 41);
    }

    if (options.includePauses) {
      statusesForOvertimeOrPenalties.push(16, 17, 18);
    }

    if (options.includeFinished) {
      statusesForOvertimeOrPenalties.push(32, 33);
    }

    return _.contains(statusesForOvertimeOrPenalties, status);
  };

  svs.themes.sport_futsal.matchNotice = function (match) {
    var matchStatus, penaltyResult;

    switch (match.status) {
      case 16:
        matchStatus = 'Väntar på förlängning';
        break;

      case 17:
        matchStatus = 'Paus i förlängning';
        break;

      case 18:
        matchStatus = 'Väntar på straffläggning';
        break;

      case 20:
        matchStatus = 'Första övertidsperioden';
        break;

      case 21:
        matchStatus = 'Andra övertidsperioden';
        break;

      case 22:
        matchStatus = 'Straffläggning';
        break;

      case 23:
        matchStatus = 'Uppskjuten';
        break;

      case 24:
        matchStatus = 'Försenad matchstart';
        break;

      case 25:
        matchStatus = 'Inställd';
        break;

      case 26:
        matchStatus = 'Avbruten';
        break;

      case 28:
        matchStatus = 'Stoppad av domare';
        break;

      case 33:
        penaltyResult = getPenaltyResult(match.result);
        matchStatus = "Straffar".concat(penaltyResult.length > 0 ? ": ".concat(penaltyResult) : '');
        break;

      default:
        matchStatus = '';
        break;
    }

    return matchStatus;
  };

  svs.themes.sport_futsal.isLive = function (status) {
    if (window.location.href.indexOf('isMocked') > -1) {
      return true;
    }

    if (_.contains([1, 2, 14, 16, 17, 18, 19, 20, 21, 22], status)) {
      return true;
    }

    return false;
  }; 


  svs.themes.sport_futsal.subscribeMatch = function (params) {
    if (svs.themes.isDateHoursDiff(params.time, -5) && !svs.themes.sport_futsal.isEnded(params.status)) {
      return true;
    }

    return false;
  };

  svs.themes.sport_futsal.hasStarted = function (status) {
    return status > 0 && status !== 23 && status !== 24 && status !== 25;
  };

  function getPenaltyResult(result) {
    var pentaltyStr = '';

    _.each(result, function (oResult) {
      if (_.isObject(oResult)) {
        if (oResult.type === 4) {
          if (oResult.homePeriod && oResult.awayPeriod) {
            pentaltyStr = "".concat(oResult.homePeriod, " - ").concat(oResult.awayPeriod);
          }
        }
      }
    });

    return pentaltyStr;
  }


  svs.themes.sport_futsal.getStatusText = function (options) {
    var text = '';
    options = _.defaults({}, options, {
      statusId: null,
      startTime: null,
      statusTime: null,
      getStartTime: true
    });
    var status = options.statusId;

    if (svs.themes.sport_futsal.isLive(status)) {
      if (status === 1) {
        text = '1:A';
      } else if (status === 2) {
        text = '2:A';
      }

      if (_.contains([14, 16, 17, 18], status)) {
        text = 'PAUS';
      } else if (_.contains([19, 20, 21], status)) {
        text = 'ÖT';
      } else if (status === 22) {
        text = 'STR';
      }
    } else if (svs.themes.sport_futsal.isEnded(status)) {
      if (_.contains([31], status)) {
        text = 'FT';
      } else if (_.contains([32, 33, 41], status)) {
        text = 'SLUT';
      } else if (status === 28) {
        text = 'UPPH';
      } else {
        text = 'SLUT';
      }
    }

    return text;
  };
})(svs);
 })(window);